import React, { useState } from 'react';

const FaqDropdown = ({ title, content, Index }) => {
  const [isOpen, setIsOpen] = useState(false);


  return (
    <div className={`bg-[radial-gradient(circle,#171A26_0%,#0C0E16_66.67%)] text-white p-2 sm:p-6 w-[100%]  md:w-[45%] lg:[100]  font-sans
     rounded-[40px] border-2 border-[#FFFFFF] 
    ${Index % 2 === 1 ? "rounded-tl-[10px] rounded-bl-[20px]" : "rounded-tr-[10px] rounded-br-[20px]"
      } 
    `}>
      <div
        className="flex justify-between items-center cursor-pointer font-bold"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`text-[14px] md:text-[18px] lg:text-[22px] xl:text-[24px]  text-left 
        ${isOpen ? "line-clamp-3" : "line-clamp-1"}`}>{title}</span>
        <span
          className={`transform transition-transform duration-300 text-2xl leading-none ${isOpen ? 'rotate-180' : 'rotate-0'
            }`}
        >
          <img
          // ${openItems[principle.id] ? '' : 'rotate-180'}
            className={`w-5 h-5 transform transition-transform duration-300 `}
            src='/assets/services/1/angle-down.png'
            alt='angle-down'
          />
        </span>
      </div>
      <div
        className={`mt-4 pt-4 border-t border-dashed border-white overflow-hidden transition-all duration-1000 ease-in-out ${isOpen ? 'max-h-96 block' : 'max-h-0 hidden'
          }`}
      >
        <div className="space-y-4">

          <p className="text-base leading-relaxed">
            {content}
          </p>

        </div>
      </div>
    </div>
  );
};

export default FaqDropdown;